import React, { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import env from 'env';
import GeneralContext from './General.context';
import { getResolveUrl } from 'utils';
import { DATA_ROOM_ROUTE, SHAREABLE_LINKS_ROUTE } from 'data/global';
import useMixpanelPageEvent from 'hooks/useMixpanelPageEvent';

const WHITE_LABEL_ROUTES = [DATA_ROOM_ROUTE, SHAREABLE_LINKS_ROUTE];

const General: React.FC = (props) => {
  const { children } = props;

  const isSafari = useMemo(
    () =>
      !!(
        navigator.vendor &&
        navigator.vendor.indexOf('Apple') > -1 &&
        navigator.userAgent &&
        navigator.userAgent.indexOf('CriOS') === -1 &&
        navigator.userAgent.indexOf('FxiOS') === -1
      ),
    [],
  );

  const { pathname } = useLocation();

  const mixpanelPageEvent = useMixpanelPageEvent();

  const isWhitelabeledRoute = useMemo(
    () => WHITE_LABEL_ROUTES.some((route) => pathname.startsWith(route)),
    [pathname],
  );

  useEffect(() => {
    // Redirect from WL subdomain to resolve domain
    if (window.location.origin !== env.URL && !isWhitelabeledRoute) {
      window.location.href = getResolveUrl(pathname);
    } else mixpanelPageEvent();
  }, [isWhitelabeledRoute, pathname, mixpanelPageEvent]);

  return (
    <GeneralContext.Provider value={{ isSafari }}>
      {children}
    </GeneralContext.Provider>
  );
};

export default General;
